function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5872"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35780",
    d: "M2371.517 1936.307a1.792 1.792 0 0 1 1.617 1.377v6.485a5.571 5.571 0 0 1-.293.567 1.656 1.656 0 0 1-1.321.752.546.546 0 0 1-.354.09h-7.146a1.215 1.215 0 0 1-.247-.023 1.829 1.829 0 0 1-1.456-2v-5.321a1.843 1.843 0 0 1 1.514-1.992 2.428 2.428 0 0 1 .465-.026h6.681a.8.8 0 0 1 .54.091z",
    transform: "translate(-2341.14 -1921.84)",
    style: {
      fill: "#8a5e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35781",
    d: "M2159.582 1862.487h7.366c.145 0 .29 0 .435.006 0 1.537 0 3.073-.012 4.61a2.936 2.936 0 0 1-2.29 2.886 3.754 3.754 0 0 1-.863.092h-18.754c-1.807 0-3.614.007-5.42.006a.657.657 0 0 1-.423-.055.242.242 0 0 1 .192-.087c.792-.009 1.585-.046 2.17.008a2.9 2.9 0 0 1-1.828-1.985 3.136 3.136 0 0 1-.126-.922v-18.288a3.026 3.026 0 0 1 1.514-2.7 1.911 1.911 0 0 1 .775-.268c.032-.031-.038-.051-.008-.022.012.011.006.02-.017.026a2.5 2.5 0 0 1-.708.071h-1.5c-.143 0-.294.022-.411-.1a.706.706 0 0 1 .424-.053c1.006 0 2.012 0 3.018.006a7.788 7.788 0 0 1 1.273-.052h14.667q2.273 0 4.546.01a1.248 1.248 0 0 1 .34.028 1.135 1.135 0 0 0 .521.047 2.909 2.909 0 0 1 2.9 2.917c.011 1.545.007 3.09.01 4.635l-7.369.006c-.124 0-.248.005-.373.008a5.683 5.683 0 0 1-1.268.085 1.624 1.624 0 0 0-1.685 1.663c-.019.934 0 1.868-.005 2.8s-.007 1.869 0 2.8a1.646 1.646 0 0 0 1.028 1.6 1.574 1.574 0 0 0 .639.11 3.9 3.9 0 0 1 1.242.112z",
    transform: "translate(-2137.002 -1838.848)",
    style: {
      fill: "#d7a494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35782",
    d: "M2111.616 1846.874h2.7c-.066.1-.164.1-.244.131a2.962 2.962 0 0 0-2.009 2.784c0 6.1.012 12.192-.009 18.288a3.139 3.139 0 0 0 2.241 3.06h-2.738a2.9 2.9 0 0 1-2.484-2.243 2.813 2.813 0 0 1-.068-.554v-18.66a2.892 2.892 0 0 1 2.611-2.806z",
    transform: "translate(-2108.935 -1839.95)",
    style: {
      fill: "#cf8f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35783",
    d: "M2202.507 1779.183c-.1.09-.217.055-.328.055h-20.2c-.1 0-.209.031-.3-.043l6.215-2.8q2.924-1.315 5.852-2.624c.454-.2.913-.4 1.36-.618.2-.1.312-.077.4.141.153.363.33.717.5 1.073.043.09.063.205.192.222.628 1.341 1.27 2.675 1.87 4.029a.694.694 0 0 0 .746.491c1.077-.027 2.155-.01 3.232-.008a.607.607 0 0 1 .446.085z",
    transform: "translate(-2175.558 -1772.316)",
    style: {
      fill: "#94d5a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35784",
    d: "M2361.942 1779.112c-1.308 0-2.617 0-3.925.006a.423.423 0 0 1-.451-.281c-.616-1.336-1.245-2.666-1.868-4-.046-.1-.113-.2-.05-.322 1.078-.484 2.156-.966 3.231-1.456.152-.069.235-.067.313.1q1.366 2.948 2.742 5.892a.2.2 0 0 1 .008.061z",
    transform: "translate(-2335.005 -1772.247)",
    style: {
      fill: "#78c1a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35785",
    d: "M2346.2 1946.628c-.435 0-.871.011-1.306 0a1.682 1.682 0 0 1-1.678-1.656q-.024-2.924 0-5.849a1.7 1.7 0 0 1 1.7-1.665c.446 0 .892.005 1.337.008a1.867 1.867 0 0 0-1.375 1.989c.03 1.774.009 3.548.009 5.322a1.716 1.716 0 0 0 1.179 1.775 1.275 1.275 0 0 1 .134.076z",
    transform: "translate(-2323.625 -1922.988)",
    style: {
      fill: "#785252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35786",
    d: "M2396.245 1966.414a2.263 2.263 0 0 1 .006 4.308.475.475 0 0 1-.384-.059 2.3 2.3 0 0 1-1.266-2.121 2.275 2.275 0 0 1 1.265-2.056.444.444 0 0 1 .379-.072z",
    transform: "translate(-2370.735 -1949.511)",
    style: {
      fill: "#f1f1f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35787",
    d: "M2381.365 1965.181a2.284 2.284 0 0 0-1.567 2.362 2.32 2.32 0 0 0 1.574 1.946 2.235 2.235 0 0 1-2.775-1.187 2.185 2.185 0 0 1 .355-2.464 2.22 2.22 0 0 1 2.338-.707.269.269 0 0 1 .075.05z",
    transform: "translate(-2355.855 -1948.278)",
    style: {
      fill: "#f1f1f2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditWallet);
export default __webpack_public_path__ + "static/media/creditWallet.355faec4a238d7235fef5def61076807.svg";
export { ForwardRef as ReactComponent };